module.exports = __webpack_public_path__ + "img/body-1-lg.7f15fd7c.png";